<script lang="ts" setup>
import { useLang } from '~/composables/useLang'

defineProps<{
  isVisible: boolean
}>()

const emit = defineEmits(['handle', 'onButtonClick'])
const { t } = useLang()

const close = (value: boolean) => {
  if (!value) {
    emit('handle', false)
  }
}

const onButtonClick = () => {
  emit('onButtonClick', false)
}
</script>

<template>
  <div class="modal-quick-reservation-out-of-stock">
    <Modal :visible="isVisible" size-md :hide-on-click-outside="false" @handle="close">
      <div class="flex flex-col gap-8">
        <i class="fa-solid fa-times text-lg absolute top-0 right-0 p-3 cursor-pointer" @click="close(false)" />
        <div class="flex justify-center flex-col items-center">
          <h4 class="lg:text-[36px] mb-5">{{ t('offers.reservation.reservation_out_of_stock_title') }}</h4>
          <span> {{ t('offers.reservation.reservation_out_of_stock_description') }} </span>
        </div>
        <Button arrow class="w-full" @click.prevent="onButtonClick">
          {{ t('my_orders.choose_products') }}
        </Button>
      </div>
    </Modal>
  </div>
</template>
